module.exports = __webpack_public_path__ + "static/media/imagery2.d0a13eb9.jpg";